import React from "react";
import { Link } from "react-router-dom";
import logo from "../../src/assets/images/header-logo.svg";
import { useReferrer } from "../hooks/useReferrer";
import ReferrerManager from "../utils/ReferrerManager";
import { Menu, X } from "lucide-react";

export default function Navbar({ onToggleSidebar, isSidebarOpen }) {
  const referral = ReferrerManager.getReferrerWithSubdomainFallback();

  const {
    dataBuyer,
    referrer,
    isLoading: referrerLoading,
    displayConfig,
  } = useReferrer();

  // Debug logging to see if Navbar gets the updated data
  // console.log('=== Navbar Debug ===');
  // console.log('referral (from URL):', referral);
  // console.log('referrer (from hook):', referrer);
  // console.log('dataBuyer:', dataBuyer);
  // console.log('displayConfig:', displayConfig);
  // console.log('==================');

  return (
    <header className="bg-white shadow-sm py-3 px-4">
      <div className="max-w-6xl mx-auto grid grid-cols-3 items-center">
        <div className="flex items-center">
          {onToggleSidebar && (
            <button
              type="button"
              onClick={onToggleSidebar}
              aria-label={isSidebarOpen ? "Close menu" : "Open menu"}
              className="md:hidden mr-2 inline-flex items-center justify-center rounded-md border border-gray-200 p-2 text-gray-600 hover:bg-gray-50"
            >
              <span className="sr-only">
                {isSidebarOpen ? "Close menu" : "Open menu"}
              </span>
              <span className="inline-flex items-center justify-center">
                {isSidebarOpen ? (
                  <X className="w-5 h-5" />
                ) : (
                  <Menu className="w-5 h-5" />
                )}
              </span>
            </button>
          )}
        </div>

        <div className="flex justify-center">
          <Link to="/" className="flex items-center">
            {/* Logo logic based on referrer */}
            <div className="flex items-center">
              <div className="flex -space-x-2">
                {/* Show partner logo if not undefined and not dimo */}
                {referral && referral !== "dimo" && displayConfig.logoUrl && (
                  <div className="w-10 h-10 rounded-full bg-white border-2 border-gray-200 flex items-center justify-center shadow-sm overflow-hidden">
                    <img
                      src={displayConfig.logoUrl}
                      alt={displayConfig.partnerName || "Partner"}
                      className="w-8 h-8 object-contain"
                    />
                  </div>
                )}
                {/* Show DIMO logo if referrer is dimo */}
                {referral === "dimo" && (
                  <div className="w-8 h-8 rounded-full bg-white border-2 border-gray-200 flex items-center justify-center shadow-sm overflow-hidden">
                    <img
                      src="/logos/dimo_logo.png"
                      alt="DIMO"
                      className="w-6 h-6 object-contain"
                    />
                  </div>
                )}
                {/* Always show Ownli logo */}
                {/* <div className="w-8 h-8 rounded-full bg-white border-2 border-gray-200 flex items-center justify-center shadow-sm overflow-hidden">
                  <img
                    src="/logos/ownli_logo.png"
                    alt="Ownli"
                    className="w-6 h-6 object-contain"
                  />
                </div> */}
              </div>
            </div>
          </Link>
        </div>
      </div>
      <div />
    </header>
  );
}
